var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.713,
    height: 13.83,
    viewBox: "0 0 18.713 13.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Show",
    "data-name": "Iconly/Bold/Show"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Show"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M9.357,0a9.123,9.123,0,0,1,5.368,1.769,12.386,12.386,0,0,1,3.934,4.895.586.586,0,0,1,0,.495c-1.953,4.174-5.431,6.672-9.3,6.672H9.348c-3.861,0-7.339-2.5-9.293-6.672a.585.585,0,0,1,0-.495C2.008,2.489,5.486,0,9.348,0h0Zm0,3.562A3.511,3.511,0,0,0,5.705,6.915a3.509,3.509,0,0,0,3.651,3.344A3.507,3.507,0,0,0,13,6.915,3.508,3.508,0,0,0,9.357,3.562Zm0,1.255a2.193,2.193,0,0,1,2.273,2.1A2.192,2.192,0,0,1,9.358,9,2.194,2.194,0,0,1,7.076,6.913,2.027,2.027,0,0,1,7.121,6.5h.046a1.808,1.808,0,0,0,1.871-1.66A1.967,1.967,0,0,1,9.358,4.818Z",
    transform: "translate(0)",
    fill: "#142e38"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFull);
export default __webpack_public_path__ + "static/media/eye-full.78f6379cd2f33a0d8688beab5cb00b38.svg";
export { ForwardRef as ReactComponent };